module.exports = __webpack_public_path__ + "static/media/donbosco17.3f26044a.jpg";